export default __webpack_public_path__ + "static/cf-product-thumb-2-1400-20dfd713d7a8ead7138f4cd078d6f12b.jpg";